import { ApiExplorerInput } from '@squareup/dex-types-shared-api-explorer';
import {
  apiExplorerInputToFetchBody,
  apiExplorerInputToFormData,
  apiExplorerInputToQueryString,
  apiExplorerInputToUrlPath,
} from '@squareup/dex-utils-shared-api-explorer';
import { useMemo } from 'react';

const useTransformInputForApiRequest = (
  input: ApiExplorerInput,
  path: string | undefined,
  supportsFileUpload?: boolean | undefined
) => {
  return useMemo(() => {
    if (!path) {
      return { path: '', body: undefined };
    }
    const newPath = apiExplorerInputToUrlPath(input, path);
    const body = apiExplorerInputToFetchBody(input);
    const queryString = apiExplorerInputToQueryString(input);
    const formData = apiExplorerInputToFormData(
      input,
      body,
      supportsFileUpload || false
    );

    return {
      path: `${newPath}${queryString}`,
      body,
      formData,
    };
  }, [input, path, supportsFileUpload]);
};

export { useTransformInputForApiRequest };
